export default "__VITE_ASSET__D3ZD9cEq__"